import { createAsyncThunk } from '@reduxjs/toolkit';
import { patchFloorplanPlacement } from '../services/patchFloorplanPlacement.service';

export const updateFloorplanPlacement = createAsyncThunk(
  'floorplans/updateFloorplanPlacement',
  async ({ projectId, placementId, x, y, direction }, { rejectWithValue }) => {
    try {
      const updateParams = { x, y };
      if (direction !== undefined) updateParams.direction = direction;
      const placement = await patchFloorplanPlacement(
        projectId,
        placementId,
        updateParams
      );
      return placement;
    } catch (err) {
      return rejectWithValue({ message: err.message, placementId });
    }
  }
);
